import { href, Navigate, Outlet, useParams } from 'react-router';

import { useProfile } from '~entities/user';
import { ROUTES } from '~shared/routes';

export function AuthGuard() {
  const { group = '' } = useParams();
  const { profile, isLoading } = useProfile();

  if (isLoading) {
    return null;
  }

  if (!profile) {
    return <Navigate to={href(ROUTES.login, { group })} replace />;
  }

  return <Outlet />;
}
